import { useAuthStore } from '@stores/authStore';
import { Permission, canAccessPage, hasPermission } from '@consts/permissions';

export const usePermissions = () => {
  const authStore = useAuthStore();

  const userPermissions = authStore.user?.authorizations || [];

  const canAccess = (requiredPermissions: Permission[]): boolean => {
    return hasPermission(userPermissions, requiredPermissions);
  };

  const canAccessPath = (path: string): boolean => {
    return canAccessPage(userPermissions, path);
  };

  const hasAnyPermission = (permissions: Permission[]): boolean => {
    return permissions.some((permission) => userPermissions.includes(permission));
  };

  const hasAllPermissions = (permissions: Permission[]): boolean => {
    return permissions.every((permission) => userPermissions.includes(permission));
  };

  const isAdmin = (): boolean => {
    return userPermissions.includes('*');
  };

  return {
    userPermissions,
    canAccess,
    canAccessPath,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
  };
};
